import { Link as RouterLink } from 'react-router-dom';
import { Typography, AppBar, Toolbar, CardMedia } from '@material-ui/core';

interface IProps {
    children?: React.ReactNode
}

let Topbar = ({ children }: IProps) => {
    return (
        <AppBar elevation={0} position="sticky">
            <Toolbar variant="dense">
                <RouterLink to="/">
                    <CardMedia
                        component="img"
                        src="/images/Videndum_Media_Solutions_Logo_Black.svg"
                        height={56}
                    />
                </RouterLink>
                {process.env.REACT_APP_ENV === "staging" &&
                    <Typography>
                        <b>staging env.</b>
                    </Typography>
                }
                {children}
            </Toolbar>
        </AppBar>
    );
};

export default Topbar;